import { getFunctions, httpsCallable } from 'firebase/functions'

interface RegisterRequest {
  email: string
  password: string
}

interface SuccessResponse {
  message: string
  firebaseToken: string
}

interface ErrorResponse {
  error: string | object
}

export default function useRegisterCloudFunction() {
  const functions = getFunctions()
  const registerCloudFunction = httpsCallable<RegisterRequest, SuccessResponse | ErrorResponse>(functions, 'firebaseRegister')

  const sendRegisterRequest = async (email: string, password: string) => {
    return registerCloudFunction({ email, password })
  }

  return { sendRegisterRequest }
}
